// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:32:52

export default {
  "id": "domino-world",
  "slug": "domino-world",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2166d2fa6eb64dcda7e47e9a848ac9dc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2166d2fa6eb64dcda7e47e9a848ac9dc/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Domino World",
      "description": "Play a timeless game of dominoes where strategy rules and every move matters. Unlock exclusive trophies and collectible wooden sets as you progress. Perfect for puzzle enthusiasts seeking endless fun and challenges.\n",
      "instructions": "Dominoes involves placing tiles to match numbers and score points. You can customize your game with 8 collectible domino sets and choose between Block and Draw modes for varied gameplay. Accelerate your progress by collecting sets and unlock exclusive bonuses through the Trophy Road.\n",
      "genres": [
        "Boardgames"
      ],
      "tags": [
        "block",
        "board",
        "domino",
        "logic"
      ]
    },
    "zh-CN": {
      "title": "多米诺世界",
      "description": "玩一场永恒的多米诺骨牌游戏，策略为王，每一步都至关重要。随着你的进步，解锁独家奖杯和可收集的木质套装。非常适合寻求无尽乐趣和挑战的益智爱好者。",
      "instructions": "多米诺骨牌是一款通过放置骨牌匹配数字并得分的游戏。你可以通过8个可收集的多米诺骨牌套装来定制你的游戏，并选择方块模式和抽牌模式以获得不同的游戏体验。通过收集套装加速你的进度，并通过奖杯之路解锁独家奖励。",
      "genres": [
        "桌面游戏"
      ],
      "tags": [
        "方块",
        "棋盘",
        "多米诺",
        "逻辑"
      ]
    },
    "zh-TW": {
      "title": "多米诺世界",
      "description": "玩一場不朽的雙六遊戲，策略主宰每一步。隨著進度解锁獨家獎杯和可收集的木製組合。適合尋求無盡樂趣和挑戰的謎題愛好者。",
      "instructions": "多米诺骨牌涉及放置骨牌以匹配數字並得分。您可以自訂遊戲，使用8組可收集的多米諾骨牌集，並在區塊和抽牌模式之間選擇，以獲得多樣化的遊戲體驗。通過收集組合加速您的進步，並在獎勵之路中解鎖獨家獎勵。",
      "genres": [
        "桌面遊戲"
      ],
      "tags": [
        "阻塞",
        "棋盤",
        "雙六",
        "邏輯"
      ]
    },
    "zh-HK": {
      "title": "雲石地盤世界",
      "description": "玩一場永不凋零的骨牌遊戲，策略為王，每一步都關乎勝負。隨著進展，解锁獨家獎杯和可收藏的木製套件。適合尋求無盡樂趣和挑戰的謎題愛好者。",
      "instructions": "多米諾骨牌遊戲涉及放置骨牌以匹配數字並得分。你可以自定義遊戲，使用8套可收集的多米諾骨牌集，並選擇阻塞和抽牌模式以享受不同的遊戲體驗。通過收集套件加速進度，並在獎勵道路中解鎖獨家獎勵。",
      "genres": [
        "桌面遊戲"
      ],
      "tags": [
        "阻塊",
        "棋盤",
        "雙六",
        "邏輯"
      ]
    },
    "ja": {
      "title": "ドミノ・ワールド",
      "description": "永遠のドミノゲームを楽しんで、戦略が支配し、一つ一つの動きが大切です。進むにつれて、特別なトロフィーと収集品の木製セットを解鎖しましょう。終わりなき楽しみと挑戦を求めるパズルの愛好家におすすめです。",
      "instructions": "ドミノズは、数字を一致させるタイルを配置してポイントを獲得するゲームです。8種類の収集可能なドミノセットでゲームをカスタマイズし、ブロックとドロー modesを選択して遊び方を変えることができます。セットを収集して進捗を加速し、トロフィーロードを通じて特別なボーナスを解除してください。",
      "genres": [
        "ボードゲーム"
      ],
      "tags": [
        "ブロック",
        "ボード",
        "多米ノ",
        "ロジック"
      ]
    },
    "ko": {
      "title": "도미노 월드",
      "description": "무시무시한 도미노 게임을 즐겨보세요. 전략이 규칙이며, 매 이동이 중요합니다. 진행에 따라 독점 트로피와 수집할 수 있는 나무 세트를 해금하세요. 끝없는 재미와 도전을 찾는 패자리들이 이상합니다.",
      "instructions": "도미노는 숫자를 일치시키기 위해 타일을 배치하고 점수를 얻는 게임입니다. 8개의 수집 가능 도미노 세트로 게임을 맞추고 블록과 드로우 모드 중 하나를 선택하여 다양한 게임 플레이를 즐길 수 있습니다. 세트를 수집하여 진행도를 가속화하고, 트로피 로드를 통해 독점 보너스를 해금하세요.",
      "genres": [
        "보드게임"
      ],
      "tags": [
        "블록",
        "보드",
        "돔뉴스",
        "로직"
      ]
    },
    "fr": {
      "title": "Monde des Dominos",
      "description": "Jouez à un jeu de dominoes intemporel où la stratégie prévaut et où chaque coup compte. Débloquez des trophées exclusifs et des ensembles en bois collectibles au fur et à mesure de votre progression. Idéal pour les amateurs de puzzles à la recherche de divertissement et de défis infinis.",
      "instructions": "Le多米诺骨牌游戏涉及放置瓷砖以匹配数字并得分。您可以通过8个可收集的多米诺骨牌套装来定制游戏，并可选择阻塞和抽取模式以享受不同的游戏体验。通过收集套装加速您的进度，并通过奖杯之路解锁独家奖励。",
      "genres": [
        "Jeux de plateau"
      ],
      "tags": [
        "bloc",
        "plateau",
        "domino",
        "logique"
      ]
    }
  }
};
